<template>
  <dir>
    <el-row>
      <el-col>
        <el-card>
          <div class="tui-list">
            <div
              class="tui-listItem"
              v-for="(item, index) in toolList"
              :key="index"
            >
              <img :src="item.img" alt="" />
              <div>{{ item.title }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </dir>
</template>
<script>
export default {
  data() {
    return {
      toolList: [
        {
          img: require("../../assets/tool-f1.png"),
          title: "上海学前教育网",
        },
        {
          img: require("../../assets/tool-f2.png"),
          title: "园园通",
        },
        {
          img: require("../../assets/tool-f3.png"),
          title: "教师慧学平台",
        },
        {
          img: require("../../assets/tool-f4.png"),
          title: "情感课程家园互通平台",
        },
        {
          img: require("../../assets/tool-f5.png"),
          title: "家园互动平台",
        },
        {
          img: require("../../assets/tool-f6.png"),
          title: "智慧校园管理系统",
        },
        {
          img: require("../../assets/tool-f7.png"),
          title: "数字资源管理系统",
        },
        {
          img: require("../../assets/tool-f8.png"),
          title: "智能顶端雾化系统",
        },
        {
          img: require("../../assets/tool-f9.png"),
          title: "智慧保健管理系统",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.tui-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .tui-listItem {
    width: calc(100% / 9);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      width: 70px;
      height: 70px;
    }
    div {
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      padding-top: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>